import { useState, useEffect } from 'react'

// Keeps a table's sort column/direction across reloads and navigation.
export function usePersistentSort(sectionKey, defaultCol = 'product_id') {
  const k = `sort_${sectionKey}`
  const saved = (() => {
    try { return JSON.parse(localStorage.getItem(k) || 'null') } catch { return null }
  })()
  const [sortCol, setSortCol] = useState(saved?.col ?? defaultCol)
  const [sortDir, setSortDir] = useState(saved?.dir ?? 'asc')
  useEffect(() => {
    try { localStorage.setItem(k, JSON.stringify({ col: sortCol, dir: sortDir })) } catch {}
  }, [k, sortCol, sortDir])
  return { sortCol, setSortCol, sortDir, setSortDir }
}
